export default "__VITE_ASSET__DgxMtfte__"